export const criteriaSectionMessagesEn = {
  // cohort builder components - cohortBuilderDefinitionCard
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.variableName': 'Variable name',
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.type': 'Type',
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.off': 'Off',
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.inclusion': 'Inclusion',
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.exclusion': 'Exclusion',
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.criteria': 'Criteria selection',

  'projects.cohortBuilderPage.criteriaSection.title': 'Criteria',
  'projects.cohortBuilderPage.criteriaSection.noDefinitionVariablesMainMsg': 'No criteria',
  'projects.cohortBuilderPage.criteriaSection.noDefinitionVariablesSubMsg':
    'Define a criterion to get started',
  'projects.cohortBuilderPage.criteriaSection.indexDateTitle': 'Index date',
  // New messages for redesigned UI
  'projects.cohortBuilderPage.criteriaSection.emptyMainMsg': 'No definition',
  'projects.cohortBuilderPage.criteriaSection.emptySubMsg':
    'Add an index date or criteria to get started',

  // Error tooltip for criteria section header (aggregated across AVs)
  'projects.cohortBuilderPage.criteriaSection.errorTooltip':
    '{count, plural, one {# analytical variable has} other {# analytical variables have}} unresolved concept groups',
  'projects.cohortBuilderPage.criteriaSection.warningTooltip':
    '{count, plural, one {# analytical variable has} other {# analytical variables have}} concept group warnings',
  // Error tooltip for a single AV (number of unresolved concept groups)
  'projects.cohortBuilderPage.criteriaSection.avErrorTooltip':
    '{count, plural, one {# unresolved concept group} other {# unresolved concept groups}}',

  // V2 empty state messages (Research Assistant workflow)
  'projects.cohortBuilderPage.criteriaSection.v2.emptyMainMsg': 'No criteria defined',
  'projects.cohortBuilderPage.criteriaSection.v2.emptySubMsg':
    'Create analytical variables with the Research Assistant to define cohort criteria',

  // Single-writer lock tooltips (OR-6078): why a criterion's edit/delete is
  // disabled while the agent owns the cohort.
  'projects.cohortBuilderPage.criteriaSection.lock.agentWorking':
    'The research assistant is working — wait for it to finish before editing.',
  'projects.cohortBuilderPage.criteriaSection.lock.assembling':
    'This cohort is still being assembled — wait until all criteria are resolved before editing.',
  'projects.cohortBuilderPage.criteriaSection.lock.processing': 'This cohort is processing.',
  'projects.cohortBuilderPage.criteriaSection.lock.finalized': 'This cohort is finalized.',
  'projects.cohortBuilderPage.criteriaSection.lock.adLocked':
    'This cohort is used by an analytical dataset.',
};
